import BaseAPI from 'utils/api/base';

import { APIRequest } from 'utils/api/types';

import { env } from 'config';

import { BindingResponse, CreateUnitRequest, SetBindingRequest, UnitResponse, UpdateUnitRequest } from './units.types';

class UnitsAPI extends BaseAPI {
  // A tree cannot be paged, so this answers with a bare array rather than a results envelope.
  loadUnits = (includeArchived = false): APIRequest<UnitResponse[]> => {
    const url = includeArchived ? '/units/?includeArchived=true' : '/units/';

    return this.request<UnitResponse[]>({
      url,
      method: 'GET',
      baseURL: env.REACT_APP_ADMIN_API_URL,
    });
  };

  setBinding = (data: SetBindingRequest): APIRequest<BindingResponse> =>
    this.request<BindingResponse>({
      url: '/bindings/',
      method: 'POST',
      data,
      baseURL: env.REACT_APP_ADMIN_API_URL,
    });

  createUnit = (data: CreateUnitRequest): APIRequest<UnitResponse> =>
    this.request<UnitResponse>({
      url: '/units/',
      method: 'POST',
      data,
      baseURL: env.REACT_APP_ADMIN_API_URL,
    });

  updateUnit = (uuid: string, data: UpdateUnitRequest): APIRequest<UnitResponse> =>
    this.request<UnitResponse>({
      url: `/units/${uuid}/`,
      method: 'PATCH',
      data,
      baseURL: env.REACT_APP_ADMIN_API_URL,
    });

  moveUnit = (uuid: string, parent: string): APIRequest<UnitResponse> =>
    this.request<UnitResponse>({
      url: `/units/${uuid}/move/`,
      method: 'POST',
      data: { parent },
      baseURL: env.REACT_APP_ADMIN_API_URL,
    });

  // Delete, as the customer sees it: the unit goes inactive and its children move to the destination.
  deleteUnit = (uuid: string, destination: string): APIRequest<UnitResponse> =>
    this.request<UnitResponse>({
      url: `/units/${uuid}/archive/`,
      method: 'POST',
      data: { destination },
      baseURL: env.REACT_APP_ADMIN_API_URL,
    });
}

export default UnitsAPI;
